// extracted by mini-css-extract-plugin
export var boldText = "_7p-4";
export var checkboxContainer = "_7p-6";
export var closeIcon = "_7p-i";
export var container = "_7p-0";
export var drawer = "_7p-8";
export var drawerContent = "_7p-9";
export var extraSmallText = "_7p-5";
export var fulfillmentGroupTable = "_7p-e";
export var largeText = "_7p-3";
export var loadingSpinnerContainer = "_7p-j";
export var mediumText = "_7p-2";
export var narrow = "_7p-f";
export var notificationLink = "_7p-l";
export var packageCheckIconContainer = "_7p-7";
export var slideoutHeaderActions = "_7p-g";
export var slideoutHeaderActionsShifted = "_7p-h";
export var slideoutHeaderContainer = "_7p-a";
export var slideoutModal = "_7p-c";
export var stickyHeaderWrapper = "_7p-b";
export var table = "_7p-k";
export var tableContainer = "_7p-d";
export var tertiaryText = "_7p-1";